import { AppearanceSettingsValues } from '@chilipiper/api-type-def/src/playbook'
import { FormKeys } from '@chilipiper/design-system'

export const defaultAppearanceSettings: AppearanceSettingsValues = {
  actionColor: 'rgb(84, 61, 255)',
  sideSpacing: 24,
  bottomSpacing: 24,
  themeMode: 'light',
  customTriggers: { drafts: [], published: [] },
  launcherPosition: 'right',
  companyName: '',
}

export const storybookDarkAppearanceSettings: AppearanceSettingsValues = {
  actionColor: 'rgb(255,230,210)',
  sideSpacing: 24,
  bottomSpacing: 24,
  customTriggers: { drafts: [], published: [] },
  themeMode: 'dark',
  launcherPosition: 'right',
  companyName: '',
}

export const storybookLightAppearanceSettings: AppearanceSettingsValues = {
  actionColor: 'rgb(120,0,120)',
  sideSpacing: 24,
  bottomSpacing: 24,
  customTriggers: { drafts: [], published: [] },
  themeMode: 'light',
  launcherPosition: 'right',
  companyName: '',
}

const createFormKeysFromDefaultValues = <T extends object>(defaultValues: T) =>
  Object.keys(defaultValues).reduce((acc, key) => ({ ...acc, [key]: key }), {} as FormKeys<T>)

export const settingsFormKeys = createFormKeysFromDefaultValues(defaultAppearanceSettings)
